<script lang="ts" setup>
import { Modal } from '@/types'

const authStore = useAuthStore()
const walletStore = useWalletStore()
const accessStore = useAccessStore()
const modalStore = useSharedModalStore()
const { $onError } = useNuxtApp()

onWalletReady(async () => {
  await walletStore.validateAutoSignSetupInBackground().catch($onError)
  await accessStore.fetchAccessStatus().catch($onError)

  if (
    walletStore.isAutoSignSetupComplete &&
    walletStore.isAutoSignAuthorizationComplete
  ) {
    authStore.login()
  }

  if (!accessStore.userHasAccess || !walletStore.isAutoSignComplete) {
    modalStore.openModal(Modal.EstablishConnection)
  }
})
</script>

<template>
  <LazyModalsAccess v-if="modalStore.modals[Modal.EstablishConnection]" />
</template>
